import React from 'react';
import { absURL } from '../utils';

export default function MainPage() {

	return (
		<div id="mainPage" className="bg-purple h-100">
			<div className="d-flex justify-content-center align-items-center h-100">
				<div className="text-center">
					<h3>Välkommen till Bombab Quiz!</h3>

					<div className="mt-3 text-center" style={{backgroundColor: "#DAD1C2", borderRadius: "5px"}}>
						<a className="text-quizPrimary" href={absURL("/admin")}>Administratör? Klicka här för att logga in.</a>
					</div>

				</div>
			</div>
		</div>
	);
};